/**
 * Camera link health, as the shell's connection light reads it.
 *
 * ONE threshold for the whole product: a camera is "down" when its stream
 * is not running or its newest frame is older than 60 s — the same line
 * `/api/health` and LiveMonitor/CctvWall already draw (backend/main.py).
 * Never invent a second number here.
 */
import type { Camera } from "@/types/cameras";

export const CAMERA_STALE_SEC = 60;

export function isCameraDown(cam: Camera): boolean {
  if (!cam.is_active) return false; // disabled on purpose, not an outage
  if (!cam.is_running) return true;
  const age = cam.last_frame_age_sec;
  return age === null || age === undefined ? false : age > CAMERA_STALE_SEC;
}

export interface LinkSummary {
  total: number;
  down: Camera[];
}

export function summarizeLinks(cameras: Camera[] | undefined): LinkSummary {
  const active = (cameras ?? []).filter((c) => c.is_active);
  return { total: active.length, down: active.filter(isCameraDown) };
}

/** Whole minutes a down camera has been silent (null when unknown). */
export function downMinutes(cam: Camera): number | null {
  const age = cam.last_frame_age_sec;
  if (age === null || age === undefined) return null;
  return Math.max(1, Math.round(age / 60));
}
